import { Divider } from "antd";

const Xembify = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          What is XEMBIFY®?
        </p>

        <p className="m-2">
          XEMBIFY® (immune globulin subcutaneous human–klhw) is a 20% immune globulin used in the treatment of primary humoral immunodeficiency disease (PIDD) in patients 2 years of age and older. XEMBIFY is for subcutaneous administration only.
        </p>

        <p className="m-2 font-bold">
          IMPORTANT SAFETY INFORMATION
        </p>

        <div className="m-2 font-bold">
          WARNING: THROMBOSIS
        </div>

        <p className="m-2">
          Thrombosis (formation of blood clots within blood vessels) may occur with immune globulin products, including XEMBIFY. Before you take XEMBIFY, talk to your doctor if you:
        </p>

        <ul className="list-none ml-10">
          <li className="m-2">Are older</li>
          <li className="m-2">Are sedentary (need to lie down or sit down) for long periods of time</li>
          <li className="m-2">Are taking estrogen-containing medicines (birth control pills, hormone replacement therapy)
          </li>
          <li className="m-2">Have a permanent intravenous (IV) catheter
          </li>
          <li className="m-2">Have hyperviscosity of the blood (diseases such as multiple myeloma or other causes of elevated proteins in the blood)
          </li>
          <li className="m-2">Have cardiovascular (heart) problems or previous history of stroke
          </li>
        </ul>

        <p className="m-2">
          Thrombosis may occur even if you don't have any risk factors
        </p>

        <p className="m-2">
        If you are at risk of thrombosis, your doctor may prescribe XEMBIFY at the minimum dose and infusion rate. Make sure you drink plenty of fluid before taking XEMBIFY. Make sure your doctor is checking you regularly for signs and symptoms of thrombosis and is checking your blood viscosity if you are at risk of hyperviscosity
        </p>

        <p className="m-2 font-bold">
          Who should not use XEMBIFY?
        </p>

        <p className="m-2">
        XEMBIFY should not be used if you have had a severe allergic reaction to human immune globulin, or if you have been told by a doctor that you are IgA deficient and have developed antibodies to IgA and hypersensitivity after exposure to a previous plasma product
        </p>

        <p className="m-2 font-bold">
          What are possible serious side effects of XEMBIFY?
        </p>

        <p className="m-2">
          <b>Aseptic meningitis syndrome (AMS): </b>
          Aseptic meningitis is a non-infectious inflammation of the membranes that cover the brain. It causes a severe headache syndrome, which may occur with human immune globulin treatment, including XEMBIFY. If you are showing signs and symptoms of AMS, your doctor may conduct a thorough neurological evaluation including spinal tap (sampling fluid which surrounds the spinal cord) to rule out other causes of meningitis. Stopping human immune globulin treatment has resulted in the end of signs and symptoms within several days. Treatment may include analgesics (pain medicines) and/or a special procedure known as a “blood patch” to stop headache
        </p>

        <p className="m-2">
          <b>Hypersensitivity: </b>
          Severe allergic reactions may occur with immune globulin products, including XEMBIFY. If you have a severe allergic reaction, stop the infusion immediately and get medical attention. XEMBIFY contains IgA. If you have known antibodies to IgA, you may have a greater risk of developing potentially severe allergic reactions
        </p>

        <p className="m-2">
          <b>Kidney problems or failure: </b>
          Kidney problems or failure may occur with use of human immune globulin products, especially those containing
          sucrose (sugar). XEMBIFY does not contain sucrose. If you have kidney disease or diabetes with kidney
          involvement, your doctor should perform a blood test to assess your hydration level and kidney function before
          beginning immune globulin treatment and at appropriate intervals thereafter. If your doctor determines that
          kidney function is worsening, they may discontinue treatment
        </p>

        <p className="m-2">
          <b>Hemolysis: </b>
          Your doctor should monitor you for symptoms of hemolysis (destruction of red blood cells causing anemia, or
          low red blood cell count). If your doctor suspects hemolysis, they should perform additional tests to confirm
        </p>

        <p className="m-2">
          <b>Transfusion-related acute lung injury (TRALI): </b>
          TRALI is a rare but serious syndrome characterized by sudden acute respiratory distress following transfusion.
          If your doctor suspects TRALI, they will monitor you for any other lung issues. TRALI may be managed with
          oxygen therapy
        </p>

        <p className="m-2">
          <b>Transmissible infectious agents: </b>
          Because XEMBIFY is made from human blood, it may carry a risk of transmitting infectious agents such as
          viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent, and, theoretically, the Creutzfeldt-Jakob disease
          (CJD) agent. No cases of transmission of viral diseases or CJD have been associated with the use of XEMBIFY
        </p>

        <p className="m-2">
          <b>Interference with lab tests. </b>
          Because XEMBIFY contains a variety of antibodies, blood tests to determine antibody levels may be falsely
          elevated. Be sure to tell your doctor or lab technician that you are using XEMBIFY
        </p>

        <p className="m-2 font-bold">
          What are other possible side effects of XEMBIFY?
        </p>

        <p className="m-2">
          In clinical studies of XEMBIFY, some patients experienced local side effects (at the injection site) including
          pain, redness, puffiness, bruising, nodules, itching, firmness, scabbing and swelling at the site on the skin
          where the injection occurred. Some patients experienced non-injection-site side effects including cough and
          diarrhea.
        </p>

        <p className="m-2">
          Use of XEMBIFY may interfere with the immune response to virus vaccines, such as vaccines for measles, mumps,
          rubella and varicella. Tell your doctor you are taking XEMBIFY before getting vaccinations
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/Xembify-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                full Prescribing Information
              </a>
              &nbsp;for XEMBIFY.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of
              prescription drugs to the FDA. Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Xembify;
